import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import React from "react";

export const showSuccess = (message: string, title = "Success") => {
  notifications.show({
    title,
    message,
    color: "green",
    icon: React.createElement(IconCheck, { size: 16 }),
    autoClose: 3000,
  });
};

export const showError = (error: any, title = "Error") => {
  let message: string;

  if (typeof error === "string") {
    // If it's a string, use it directly
    message = error;
  } else if (error?.response?.data?.details?.validationErrors) {
    // If it's a validation error with details
    const validationErrors = error.response.data.details.validationErrors;
    const errorMessages = validationErrors
      .map((err: any) => `${err.field}: ${err.message}`)
      .join("\n");
    message = errorMessages;
  } else if (error?.response?.data?.error) {
    // If it's an error object with response data
    message = error.response.data.error;
  } else if (error?.message) {
    // If it's an error object with message
    message = error.message;
  } else {
    // Fallback for unknown error types
    message = "An unexpected error occurred";
  }

  notifications.show({
    title,
    message,
    color: "red",
    icon: React.createElement(IconX, { size: 16 }),
    autoClose: 5000,
  });
};
